import { Inject, Injectable } from '@angular/core';
import { GrowthBook } from '@growthbook/growthbook';
import { LOCAL_STORAGE } from '@techspert-io/auth';
import { from } from 'rxjs';
import { GROWTHBOOK } from '../token';

interface IBanner {
  id: string;
  text: string;
  cta: string;
  link: string;
  expires: string;
}

@Injectable()
export class BannerService {
  banner: IBanner;

  constructor(
    @Inject(GROWTHBOOK) private growthbook: GrowthBook,
    @Inject(LOCAL_STORAGE) private localStorage: Storage
  ) {}

  initialiseBanner() {
    from(this.growthbook.init()).subscribe(() => {
      this.initialise();
    });
  }

  closeBanner(): void {
    this.localStorage.setItem(`closed-banner-${this.banner.id}`, 'true');
    this.banner = null;
  }

  private initialise() {
    const banner = this.growthbook.getFeatureValue<IBanner>(
      'client-portal-banner',
      null
    );

    if (!banner) {
      this.banner = null;
      return;
    }

    const closedThisBanner = this.localStorage.getItem(
      `closed-banner-${banner.id}`
    );

    const bannerExpired = new Date(banner.expires).getTime() < Date.now();

    this.banner = closedThisBanner || bannerExpired ? null : banner;
  }
}
